<template>
  <div>
    <load-profile />
    <b-card
      no-body
      class="mb-0"
    >
      <!-- <div class="p-2">
        <b-row>
          <b-col>
            <label>{{ $t("general.entries") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </b-col>
        </b-row>
      </div> -->
      <div class="p-2">
        <div class="d-flex lang-container">
          <div>
            <label>{{ $t("general.entries") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1 w-20"
            >
              <template #no-options>
                {{ $t("selection.noOption") }}
              </template>
            </v-select>
          </div>
          <div class="d-flex align-items-center">
            <n-input
              v-model="data"
              class="lang-input w-20"
              :fields="languageFields"
              :init-value="initData"
              @input="onChange"
            />
          </div>

          <div
            v-if="$can('create', permissionType)"
            class="btn-filter-bot"
          >
            <n-button-loading
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              class="btn-submit-bot-filter"
              :loading="loadingRetrain"
              @submit="retrains"
            >
              {{ $t("field.reTrain") }}
            </n-button-loading>
          </div>
          <div v-if="$can('create', permissionType)">
            <b-button
              variant="primary"
              to="/bot/create"
              class="btn-submit-bot-filter"
            >
              {{ $t("button.create") }}
            </b-button>
          </div>
        </div>
      </div>
      <div>
        <n-table
          ref="table"
          :fields="fields"
          :items="items"
          :busy="loading"
          :current-page="params.page"
          :per-page="$store.state.pagination.perPage"
          :total="total"
          :deletable="true"
          :type="permissionType"
          :route="route"
          @destroy="destroy"
        >
          <template #cell(text)="data">
            <span v-if="data.item.text">
              <p
                v-for="(text, index) in data.item.text"
                :key="index"
              >
                - {{ text }}
              </p>
            </span>
          </template>
          <template #cell(isTrain)="data">
            <span v-if="data.item.isTrain == true">
              <p>{{ $t("field.yes") }}</p>
            </span>
            <span
              v-if="data.item.isTrain == false"
              class="displays"
            >
              <p class="text">{{ $t("field.No") }}</p>
              <div>
                <button
                  class="btnRetrain"
                  @click="reTrainData(data.item.id)"
                >
                  {{ $t("field.Train") }}
                </button>
              </div>
            </span>
          </template>
        </n-table>
        <n-pagination
          class="mt-2"
          :total="total"
          :per-page="$store.state.pagination.perPage"
          :page="query.page"
          @change="list"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BBadge,
  BLink,
  BSpinner,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Repository from '@/repositories/RepositoryFactory'
import NPagination from '@/components/NPagination'
import NTable from '@/components/NTable'
import { avatarText } from '@core/utils/filter'
import axios from 'axios'
import NInput from '@/components/NInput'
import NButtonLoading from '@/components/NButtonLoading'
import Ripple from 'vue-ripple-directive'
import SearchInputs from './searchInput'
import tableFields from './tableField'

const BotRepository = Repository.get('bot')

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BLink,
    BBadge,
    BSpinner,
    NPagination,
    NTable,
    vSelect,
    BButton,
    NInput,
    NButtonLoading,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      loading: false,
      resendLoading: false,
      total: 0,
      perPageOptions: this.$store.state.pagination.perPageOptions,
      params: {
        name: this.$route.query.name || null,
        email: this.$route.query.email || null,
        isActive: this.$route.query.isActive || null,
      },
      query: {
        page: Number(this.$route.query.page) || 1,
        limit: Number(this.$route.query.limit) || 25,
      },
      avatarText,
      data: {
        languageId: null,
      },
      options: [],
      languageFields: [
        {
          key: 'languageId',
          // rules: 'required',
          type: 'async-single-selection',
          repository: 'bot',
          selectionKey: 'id',
          selectionLabel: 'translations',
          cols: 24,
        },
      ],
      listLanguage: [],
      initData: {},
      loadingRetrain: false,
    }
  },
  computed: {
    perPage: {
      get() {
        return this.$store.state.pagination.perPage
      },
      set(value) {
        this.$store.commit('pagination/SET_PER_PAGE', value)
      },
    },
  },
  watch: {
    perPage() {
      this.list(1)
    },
  },

  mounted() {
    this.getLanguage()
    this.getData()
  },
  methods: {
    updateQuerySting() {
      this.$router.replace({ query: this.query })
    },
    list(page = 1) {
      this.query.page = page
      this.query.limit = this.perPage
      this.updateQuerySting()
      this.getData()
    },
    onChange(value) {
      if (value?.languageId) {
        this.query.lang = value?.languageId
        this.getData()
      }
    },
    getLanguage() {
      this.loading = true
      BotRepository.options()
        .then(response => {
          const { data } = response.data || {}
          this.data = {
            languageId: data?.[0]?.id,
            id: data?.[0]?.id,
          }
          this.initData = this.data
          this.query.lang = data?.[0]?.id
        })
        .catch()
        .then(() => {
          this.loading = false
        })
    },
    getData() {
      this.loading = true
      BotRepository.list({
        ...this.query,
      })
        .then(response => {
          const { data } = response.data.data
          this.items = [...data]
          this.total = response.data.data.meta.total
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    async reTrainData(id) {
      this.loading = false
      await BotRepository.retrain(id)
      window.location.reload()
    },
    async retrains() {
      this.loadingRetrain = true
      try {
        await BotRepository.retrains({ language: this.data.languageId })
      } catch (error) {
      } finally {
        this.loadingRetrain = false
      }
    },
    destroy(id) {
      BotRepository.remove(id)
        .catch(() => {})
        .finally(() => {
          this.getData()
        })
    },
  },
  setup() {
    const fields = tableFields
    const searchFields = SearchInputs
    const permissionType = 'bot'
    const route = 'bot'

    return {
      fields,
      searchFields,
      permissionType,
      route,
    }
  },
}
</script>

<style lang="scss">
.lang-input span label {
  display: none !important;
}

.lang-container {
  width: 100%;
  gap: 10px;
}

.btn-filter-bot {
  display: flex;
  flex: 1;
  justify-content: end;
}

.btn-submit-bot-filter {
  height: fit-content;
}

.w-20 {
  width: 100px;
}

.lang-container .v-select.vs--single.vs--searchable {
  width: 150px;
}

.displays {
  display: flex;
  justify-items: center;
}
.btnRetrain {
  border: none;
  background: rgb(6, 172, 67);
  color: rgb(255, 255, 255);
  margin-left: 7px;
  border-radius: 5px;
  cursor: pointer;
}
@import "@core/scss/vue/libs/vue-select.scss";
</style>
